$(function(){

    // console.log('Votes JS');

    /**
     * Cookie functions
     */
     function setCookie(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
    function eraseCookie(name) {
        document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
    /*****************/

    // Check User votes status
    // Cookie {userVote}
    var userVoteStatus = getCookie('userVote');
    var userVoteCommentStatus = getCookie('userVoteComment');
    if ( userVoteStatus ) {        
        $('#vote-main-container').addClass('hidden'); // Hide vote options
        $('#section-voting-results').removeClass('hidden'); // Show results
        
        // Vote comment status
        if ( userVoteCommentStatus ) {     
            $('.voting-container').addClass('hidden');
            $('.comment-success').removeClass('hidden');
        }
    }

    function updateProgressBars(voting_results, total_votes){
        for (let index = 0; index < voting_results.length; index++) {
            const element = voting_results[index];

            let option = element.option_slug;
            let votes = element.votes;

            // Set Values
            let $parentWrapper = $('.voting-wrapper[data-vote-option-slug="' + option + '"]');
            $parentWrapper.find('.vote-total progress').val(votes);
            $parentWrapper.find('.vote-total progress').attr('max', total_votes);

            // Update percentage
            let percentage = Math.round((votes / total_votes) * 100);
            $parentWrapper.find('.vote-total .percentage .amount').text(percentage);

        }
    }

    function voting_handle_request(user_ip, campaign_id, option, submissionId, comment, comment_name, comment_email){
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('input[name="_token"]').val()
            }
         });

        let $url = '/vote/' + campaign_id;
        let formId;
        var formData = $('form#vote').serialize();
        let showCommentForm = false;
        let showCommentSuccess = false;
        let returnComment = '';

        $.ajax({
            url: $url,
            method: 'POST',
            data: {
                user_ip: user_ip,
                campaign_id: campaign_id,
                option: option,
                comment: comment,
                comment_name: comment_name,
                comment_email: comment_email,
                submissionId:submissionId
            },
            success: function(result){
                // console.log('Ajax Success');
                // console.log(result);
                returnComment = result.return_message;

                if($('form#vote input[name="submission_id"]').val() == '') {
                    //console.log('Submission_id is empty');

                    // Form ID
                    formId = result.formDbRow.id;

                    $('form#vote input[name="submission_id"]').val(formId);

                    //console.log('Submission_id is set');

                    showCommentForm = true;
                    // User voted - set Cookie
                    setCookie('userVote', 1, 3650);

                    $('#vote-main-container').addClass('hidden');
                    $('#section-voting-results').removeClass('hidden');

                }

                // Update progress bars
                let voting_results = result.voting_results;
                let total_votes = result.total_votes;

                updateProgressBars(voting_results, total_votes);

                // Hide the comment form on second store
                // if(returnComment == 'Initial store'){
                //     console.log(result.return_message);
                // }
                if(returnComment == 'Second store'){
                    // User voted - set Cookie
                    setCookie('userVoteComment', 1, 3650);

                    $('.voting-container').addClass('hidden');
                    $('.comment-success').removeClass('hidden');
                }


            },
            error: function(data) {
                // console.log('Ajax Error');
                // console.log(data);
            },
            complete:function(data) {
                // Scroll to section
                window.scrollTo(0, $('#section-voting-results').offset().top - 100);

                // NOT USED - CONDITIONAL
                // if(returnComment == 'Second store'){
                //     window.scrollTo(0, $('#section-voting-results').offset().top - 100);
                //     // $('html, body').scrollTop({
                //     //     scrollTop: $('.comment-success').offset().top
                //     // }, 2000);
                // } else{
                //     window.scrollTo(0, $('#section-voting-results').offset().top - 100);
                //     // $('html, body').scrollTop({
                //     //     scrollTop: $('#section-voting-results').offset().top
                //     // }, 2000);
                // }

            }
        });
    }


    var voteGalleryModal = $('#vote-gallery-modal');

    // init Modal
    voteGalleryModal.modal();

    // On option click save submission via ajax
    $('.option-choice').on('click', '.vote-button', function(event){

        $(this).addClass('chosen-option');

        let option = $(this).data('vote');
        let form = $('form#vote');
        let campaign_id = $('form#vote input[name="campaign_id"]').val();
        let user_ip = $('form#vote input[name="user_ip"]').val();
        let comment = $(form).find('textarea[name="comment"]').val();
        let comment_name = $(form).find('input[name="comment_name"]').val();
        let comment_email = $(form).find('input[name="comment_email"]').val();
        let submissionId = $(form).find('input[name="submission_id"]').val();


        $(form).find('input[name="option"]').val(option);

        voting_handle_request(user_ip, campaign_id, option, submissionId, comment, comment_name, comment_email);
    });

    // On Form submit save submission via ajax
    $("#vote").on('submit', function(e){
        let form = $('form#vote');
        let campaign_id = $(form).find('input[name="campaign_id"]').val();
        let user_ip = $(form).find('input[name="user_ip"]').val();
        let option = submissionId = '';
        let comment = $(form).find('textarea[name="comment"]').val();
        let comment_name = $(form).find('input[name="comment_name"]').val();
        let comment_email = $(form).find('input[name="comment_email"]').val();

        // Set Form Values
        if($(form).find('input[name="option"]').val() == ''){
            // Make sure to set the option
            if($('.option-choice .vote-button.chosen-option').length){
                option = $('.option-choice .vote-button.chosen-option').data('vote');
                $(form).find('input[name="option"]').val(option); 
            } 

        } else{
            option = $(form).find('input[name="option"]').val();
        }

        if($('form#vote input[name="submission_id"]').val() != ''){
            // Form ID
            //formId = result.formDbRow.id;

            //$('form#vote input[name="submission_id"]').val(formId);

            submissionId = $('form#vote input[name="submission_id"]').val();
        }

        voting_handle_request(user_ip, campaign_id, option, submissionId, comment, comment_name, comment_email);


        return false;
    });

    if($('.vote-total progress').length){
        let highest = 0;
        let highestElement = '';

        $('.vote-total progress').each(function( index, element ) {
            highest = Math.max(highest, parseFloat(this.value));
        });

        $('.vote-total progress[value="'+highest+'"]').parents('.vote-total').addClass('highest');
    }

    // Vote options slider
    let votingMainSlider = $('#voting-main-slider.owl-carousel').owlCarousel({
        loop:false,
        autoplay: false,
        // margin:10,
        nav:false,
        //dots: true,
        items:1,
        autoHeight:true,
        //dotsContainer: '#voting-nav',
        responsive : {
            // breakpoint from 0 up
            0 : {
                items:1,
                dots: false,
                dotsContainer: '#voting-nav',
            },
            // breakpoint from 480 up
            992 : {
                items:3,
                dots: false,
                mouseDrag: false,
                pullDrag: false,
                touchDrag: false,
                freeDrag: false,
                dotsContainer: false,
            }
        }
    })

    // Vote options nav
    $('#voting-nav li').on('click', function (event) {
   	 $('#voting-main-slider.owl-carousel').trigger('to.owl.carousel', [$(this).index(), 300]);
    });
    
    // Vote main slider On change
    $(votingMainSlider).on('changed.owl.carousel', function(event) {
        if(event.target.id == 'voting-main-slider'){
            $('#voting-nav li').removeClass('active');
            $('#voting-nav li').eq(event.relatedTarget.current()).addClass('active');
        }
    });


    // Vote option - media slider
    var voteGalleryOptions = {
        loop:false,
        // margin:10,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        nav:true,
        dots: false,
        items:1,
        navText: ['<i class="custom-angle-left"></i>','<i class="custom-angle-right"></i>'],
    };

    var $voteOptionSlider = $('#voting-carousel.owl-carousel');
    var voteOptionSliders = []; // store slider's HTML

    $('#voting-carousel.owl-carousel').each(function(index){
        voteOptionSliders.push($(this)[0].outerHTML);
        $(this).data('slider-id', index).owlCarousel(voteGalleryOptions);
    });


    function modalGalleyInit(event) {
        voteGalleryModal.find('#voting-carousel').addClass('is-loaded');
    }

    $('.slider-content .tab_content .js-slider-image-popup').on('click', function (event) {
        event.preventDefault();

        var sliderID = $(this).closest('.option-slider-wrapper').data('slider-id');
        var sliderContent = voteOptionSliders[sliderID];
        voteGalleryModal.find('.modal-body').html(sliderContent);

        var modalVoteGalleryOptions = voteGalleryOptions;
        modalVoteGalleryOptions.onRefreshed = modalGalleyInit;
        voteGalleryModal.find('.modal-body .option-slider-wrapper').owlCarousel(modalVoteGalleryOptions);
        // Show modal
        voteGalleryModal.modal('show')

    })
});
